import { MoonPayBuyWidget } from "@moonpay/moonpay-react";
import useProfile from "hooks/useProfile";
import { useSoundPath } from "hooks/useSoundPath";
import React, { useLayoutEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const PageHeaderWithdraw = () => {
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const { user_wallet } = useProfile();
  const playSound = useSoundPath();

  useLayoutEffect(() => {
    document.body.removeAttribute("data-moonpay-web-sdk");
    setIsVisible(false);

    const observer = new MutationObserver(() => {
      if (document.body.getAttribute("data-moonpay-web-sdk") === "true") {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    });

    const config = { attributes: true };
    observer.observe(document.body, config);

    if (document.body.getAttribute("data-moonpay-web-sdk") === "true") {
      setIsVisible(true);
    }

    return () => {
      observer.disconnect();
    };
  }, [pathname]);

  return (
    <>
      <button
        className="page-header__user-popup-action"
        onClick={() => {
          playSound('main');
          setIsVisible(true);
        }}
      >
        Withdraw Funds
      </button>
      {isVisible && (
        <MoonPayBuyWidget
          variant="overlay"
          baseCurrencyCode="usd"
          baseCurrencyAmount="100"
          defaultCurrencyCode="usdc"
          walletAddress={user_wallet}
          visible={isVisible}
        />
      )}
    </>
  );
};

export default PageHeaderWithdraw;
